// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  assetIds: __t.array(__t.string()),
  encode: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
  fps: __t.f64(),
  pool: __t.string(),
  label: __t.string(),
  startUs: __t.f64(),
  endUs: __t.f64(),
  name: __t.string(),
};
